import { ShoppingCartCTAButton } from './ShoppingCartCTAButton';

export default ShoppingCartCTAButton;
